import DOMPurify from 'isomorphic-dompurify';
import { forOwn, map, isArray, toString } from "lodash-es";

export const Utils = () => {

  // const preventXSSAttacks = (content: string) => DOMPurify.sanitize(content);
  const preventXSSAttacks = (content: string) => {     
   const  cleanedHTML = content.replace(/<([^>][^.]+)>/g, function(match, tag) {
        // is html demo after <
        return tag.match(/^(\/?[a-zA-Z][^\s>\/]*)/) ? '&lt;' + tag + '>' : match ;
    });

    return cleanedHTML;
};
  const generateRandomString = (length: number) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  };

  const secureVariables = (variables) => {
    return forOwn(variables, (value, key, object) => {
      if (Array.isArray(value)) {
        object[key] = map(value, (item) => isArray(item) ? item : DOMPurify.sanitize(item));
      } else {
        object[key] = DOMPurify.sanitize(value);
      }
    });
  };
  const preventSqlAttacks = (content:string) => {
    const sqlKeywords = [
      "SELECT", "INSERT", "UPDATE", "DELETE",
      "FROM", "WHERE", "AND", "OR", "UNION",
      "JOIN", "ORDER BY", "GROUP BY", "https", 'http', ".com", ".cn"
      ]; 
      const pattern = new RegExp(`\\b(${sqlKeywords.join("|")})\\b`, "i");
      if (pattern.test(content)) {
        return true;
      } else {
        return false;
      }
  };

  const formatDate = (date:string, screenWidth:number) => {
    const formatString = new Date(date);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const year = toString(formatString.getFullYear());
    const month = screenWidth >= 768 ? months[formatString.getMonth()] : months[formatString.getMonth()].substring(0, 3);
    const day = toString(formatString.getDate());
    return day + ' ' + month + ' ' + year;
  };
  
  const encodeString = (content: string) => {
    // eslint-disable-next-line no-useless-escape
    const enCodeData = content.replace(/\.(?!\d)/g, function(match) {
      return '&#x' + match.charCodeAt(0).toString(16) + ';';
    });
    return enCodeData;
  };
  return {
    preventXSSAttacks,
    generateRandomString,
    secureVariables,
    preventSqlAttacks,
    formatDate,
    encodeString
  };
};

export default Utils;
